import React from 'react';

//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';
import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { 
    Text, 
    TextAppearance, 
    WhiteSpace
} from '../../../components-core/packages/components-core/dist/text';
import { Link } from '../../../components-core/packages/components-core/dist/link/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { LazyImage, Image } from '../../../components-core/packages/components-core/dist/image/index';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container/index';

import { FixedWidthContainer } from '../../../components-core/packages/components-core/dist/fixed-width-container';

import { encodeHTMLEntities } from '../../helpers/encoders/Encoder';


class LinkGroup extends React.Component {

    renderInnerImage(url) {
        return (
            <Container stretchContent={true}>
                <BreakpointWrapper min={Breakpoints.b960}>
                    <FixedWidthContainer columns={4} >
                        <LazyImage src={url} srcPlaceholder={url} alt={'volkswagen'} />
                    </FixedWidthContainer>
                </BreakpointWrapper>
                <BreakpointWrapper max={Breakpoints.b960}>
                    <Divider />
                </BreakpointWrapper>
            </Container>
        )
    }

    renderInnerDescription(data) {
        return (
            <Container padding={innerDescriptionPadding} wrap={ContainerWrap.always}>
                <Text appearance={TextAppearance.label0200} bold>
                    <Link>{encodeHTMLEntities(data.title)}</Link>
                </Text>
                <Text appearance={TextAppearance.headline0250} whiteSpace={WhiteSpace.preWrap} bold>
                    {encodeHTMLEntities(data.description)}
                </Text>
            </Container>
        )
    }


    //@TugkanPilka TODO: Kodu BreakpointWrapper kullanarak tekrar yaz.
    renderSmallImages() {
        const display = typeof window !== `undefined` && window.innerWidth <= 960 ? 'column' : 'row';
        const objectsWithData = demoObjects(this.props);

        return objectsWithData.map(data =>
            <div style={{ display: 'flex', flexDirection: display, flex: 1 }} >
                <div style={{ flex: 0.4 }} >
                    {this.renderInnerImage(data.photo)}
                </div>
                <div style={{ display: 'flex', flex: 0.6, alignItems: 'center' }}>
                    {this.renderInnerDescription(data)}
                </div>
            </div>            
        )
    }

    render() {
        return (
            <IntegratorRoot>
                <ThemeProvider>
                    <Container stretchContent={true}>
                        <Layout appearance={layoutBreakpoints} rowGap={ContainerGutter.grid001} >
                            <Container 
                                padding={leftContainerPadding} 
                                gutter={ContainerGutter.dynamic0100} 
                                stretchContent={true}
                                wrap={ContainerWrap.always}
                            >
                                <AspectRatioContainer ratio={AspectRatio['1:1']}>
                                    <Image 
                                        src={this.props.custom} 
                                        alt={'volkswagen'}
                                    />
                                </AspectRatioContainer>
                                <Container wrap={ContainerWrap.always}>
                                    <Text appearance={TextAppearance.label0200} bold>
                                        <Link>{encodeHTMLEntities(this.props.custom10)}</Link>
                                    </Text>
                                    <Text appearance={TextAppearance.headline0300} bold>
                                        {encodeHTMLEntities(this.props.custom5)}
                                    </Text>
                                </Container>
                            </Container>
                            <Container 
                                padding={rightContainerPadding} 
                                wrap={ContainerWrap.always} 
                                gutter={{[Breakpoints.b960]: ContainerGutter.dynamic0100}}
                            >
                                {this.renderSmallImages()}
                            </Container>
                        </Layout>
                    </Container>
                </ThemeProvider>
            </IntegratorRoot>
        )
    }
}


const Divider = styled.div`
	margin: 24px 0 24px 0;
	border: 0;
	height: 2px;
    background-color: #DFE4E8;
    width: 100%;
`;

const defaultBreakpoints = [
    {name: 'b', columns: 12},
    {name: 'd', columns: 12},
]

const mobileBreakpoints = [
    {name: 'b', columns: 24},
    {name: 'd', columns: 24}
]

const grid001 = ContainerPadding.grid001;
const grid002 = ContainerPadding.grid002;

const grid003DefaultPadding = {
    [Breakpoints.default]: grid002,
}

const leftContainerPadding = {
    left: grid003DefaultPadding,
    right: {
        [Breakpoints.default]: grid002,
        [Breakpoints.b960]: null,
    }
}

const rightContainerPadding = {
    right: grid003DefaultPadding,
    left: {
        [Breakpoints.default]: grid002,
        [Breakpoints.b960]: grid001,
    }
}

const layoutBreakpoints = {
    [Breakpoints.default]: mobileBreakpoints,
    [Breakpoints.b960]: defaultBreakpoints,
}


const innerDescriptionPadding = { 
    left: {
        [Breakpoints.default]: grid001,
        [Breakpoints.b560]: ContainerPadding.dynamic0120 
    }, 
    right: {[Breakpoints.default]: grid001 }
}

const demoObjects = (props) => [
    {
        'photo': props.custom1,
        'title': props.custom11,
        'description': props.custom6
    },
    {
        'photo': props.custom2,
        'title': props.custom12,
        'description': props.custom7
    },
    {
        'photo': props.custom3,
        'title': props.custom13,
        'description': props.custom8
    },
    {
        'photo': props.custom4,
        'title': props.custom14,
        'description': props.custom9
    }
]

export default LinkGroup;